var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"d-flex",class:{
      'align-center': !_vm.isMobile,
      'px-12': !_vm.isMobile,
      'py-4': !_vm.isMobile,
      'py-4': _vm.isMobile,
      'px-0': _vm.isMobile,
    }},[_c('v-container',{staticStyle:{"max-width":"1100px !important"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }